angular.module('lf.common')

.directive('bindHtml', function ($compile) {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      scope.$watch(attrs.bindHtml, function bindHtmlWatchAction (val) {
        val = (val == null) ? '' : String(val);
        el.html(val);
        $compile(el.contents())(scope);
      });
    }
  };
});
